$(document).ready(function(){  
    setTimeout(function() {
      if ($('.swym-storefront-layout-default-list-container swym-storefront-layout-item').length > 3) {   
        $('.swym-storefront-layout-default-list-container .swym-storefront-layout-items-container').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: false,   
              draggable: true,   
              swipe: true,      
              swipeToSlide: true,  
              responsive: [
                  {
                  breakpoint: 1200,
                  settings: { slidesToShow: 3 }
                  },
                  {
                  breakpoint: 989,
                  settings: { slidesToShow: 2.4 }
                  },
                  {
                  breakpoint: 767,
                  settings: { slidesToShow: 2 }
                  },
                  {
                  breakpoint: 480,
                  settings: { slidesToShow: 1.5 }
                  }
              ]
        });
      }	
      else { 
      }
    }, 2000);  
  });